import { Component, OnInit, Injector } from '@angular/core';
import { AuditTrailComponent } from 'src/app/out-of-application/audit-trail/audit-trail.component';
import { UntypedFormArray, Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AlertService } from 'src/app/common/alert.service';
import { CommonService } from 'src/app/shared/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { Global } from 'src/app/Global';
import { AppTokenHandler, HTTPStatus } from 'src/app/common/app-token-handler';
import { EmployeeRecoveryService } from 'src/app/shared/employee-recovery.service';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-wave-off',
  templateUrl: './wave-off.component.html',
  styleUrls: ['./wave-off.component.css'],
  // standalone: true,
  // imports:[MatCardModule,MatRadioModule,MatDialogModule,ReactiveFormsModule]
})
export class WaveOFFComponent implements OnInit {
  /********************************Properties Declaration***********************************/
  UploadResponseFileUpload: File;
  WaiveOffCreationForm: UntypedFormGroup;
  SecondaryHeadForm: UntypedFormArray;
  formData: FormData = new FormData();
  filterList: any;
  private alertService: AlertService;
  IsSecondaryZoneVisible = false;
  LocationID: string;
  btnValue: string;
  IsSecondaryOwner: boolean;
  UserDetails: any;
  FilePath: any;
  AttachmentName: any;
  RecoveryID: string;
  showAttachmentName: string;
  IsWaiveAmountEnable: boolean = true;

  /***********************************End***************************************************/
  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    injector: Injector, private _dialog: MatDialog,
    public _global: Global, private appToken: AppTokenHandler, private _employeerecovery: EmployeeRecoveryService
    , private status: HTTPStatus) { this.alertService = injector.get(AlertService); }

  ngOnInit() {
    /*****************************GetData By QueryString*************************/
    this.UserDetails = this.appToken.getLoginUserInfo();

    /**************************************End**********************************/

    this.WaiveOffCreationForm = this._fb.group({
      RequestEntityId: [''],
      RequisitionDate: [new Date()],
      Remarks: ['', Validators.required],
      OriginalPenaltyAmount: ['', Validators.required],
      WaiveOffAmount: ['', Validators.required],
      NetRecoveryAmount: [0, Validators.required],
      IsFullWaiveOff: ['', [Validators.required]],
      FilePath: ['', [Validators.required]],
      AttachmentName: [''],
      RecoveryID: [''],
      TempBlobfileId: ['']

    });

    if (this._global.RecoveryID != null) {
      this.btnValue = 'Save';
      this.GetEmployeeRecoveryWaveOffDetailsByID(this._global.RecoveryID);
      this.IsWaiveAmountEnable = true;
    }
  }
  /****************************Section: Methods****************************/
  onfilechange(event) {
    this.UploadResponseFileUpload = event;
    this.UploadAttachment(event);
  }

  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  SaveWaveOff() {

    if (!this.WaiveOffCreationForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();
      return false;
    }
    this.status.setHttpStatus(true);

    this._employeerecovery.EmployeeRecoveryDetails(this.WaiveOffCreationForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {

        if (data.RequestEntityId !== null) {
          this.alertService.notify('success', 'Success!', data.RequestMessage);
          this._router.navigate(['admin/view-recovery']);
          this.WaiveOffCreationForm.reset();
          this.WaiveOffCreationForm.controls.Remarks.reset();
          this._dialog.closeAll();
        }
      } else {
        this.alertService.notify('warn', 'warn!', data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  GetEmployeeRecoveryWaveOffDetailsByID(RecoveryID: string) {
    //this.status.setHttpStatus(true);

    this._employeerecovery.GetEmployeeRecoveryWaveOffDetailsByID(RecoveryID).subscribe(data => {
      this.WaiveOffCreationForm.patchValue(data);
      this.WaiveOffCreationForm.controls.RecoveryID.setValue(data.RecoveryID);
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      //this.clearAutoComplete('SecondaryZoneHead');
      //this.status.setHttpStatus(false);
    });
  }

  /**********************************Method Section End****************************************/

  openAuditTrailDialog() {
    this._dialog.open(AuditTrailComponent,
      {
        width: '1000px',
        disableClose: true
      });
  }
  /****************************Error and Validation Section***********************************/
  GetFormControls(controlName) {
    return this.WaiveOffCreationForm.controls[controlName];
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.WaiveOffCreationForm.controls).forEach(field => {
      const control = this.WaiveOffCreationForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  UploadAttachment(event) {
    if (event != null) {
      if (event.target.files.length > 0) {
        const fileList: FileList = event.target.files;
        const file: File = fileList[0];
        const maxLength = 1024 * 1024 * 2;
        const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (fileExtension.toLowerCase() === 'msg' ||
          fileExtension.toLowerCase() === 'xlsx' ||
          fileExtension.toLowerCase() === 'docx' ||
          fileExtension.toLowerCase() === 'zip' ||
          fileExtension.toLowerCase() === 'pdf') {
          if (event.target.files[0].size > maxLength) {
            alert('File Size cannot be more than 2 mb.');
            event.target.value = '';
            return;
          }
          this.formData = new FormData();
          this.formData.append('Filesupload', file, file.name);
          this._employeerecovery.UploadClientResponseData(this.formData).subscribe(data => {
            if (data.RequestIsSuccess) {
              if (data.FilePath.length > 0) {
                this.alertService.notify('success', 'Success!', 'File uploaded successfully');
                event.target.value = '';
                this.formData = null;
                this.UploadResponseFileUpload = null;
                this._global.IsBulkLoad = true;
                this.WaiveOffCreationForm.controls.FilePath.setValue(data.FilePath);
                this.WaiveOffCreationForm.controls.AttachmentName.setValue(data.AttachmentName);
                this.showAttachmentName = data.AttachmentName;
                this.WaiveOffCreationForm.controls.TempBlobfileId.setValue(data.BlobFileID);

              } else {
                alert('Some error occurred while uploading a file.');
                event.target.value = '';
                this.formData = null;
                this.UploadResponseFileUpload = null;
                // this.DataExportList = data.RequestData;
                // this.exportAsXLSX(this.DataExportList);
              }
            } else {
              this.alertService.notify('warn', 'warn!', data.RequestMessage);
              event.target.value = '';
            }
          }
          );
        } else {
          alert('Please browse valid file.');
          event.target.value = '';
        }
      } else {
        event.target.value = '';
        alert('please choose only one file');
      }
    } else {
      alert('Please upload a file.');
      event.target.value = '';
    }
  }
  IsAlphaNumeric(e: any) {
    let specialKeys = new Array();
    specialKeys.push(8); //Backspace
    specialKeys.push(9); //Tab
    specialKeys.push(46); //Delete
    specialKeys.push(36); //Home
    specialKeys.push(35); //End
    specialKeys.push(37); //Left
    specialKeys.push(39); //Right
    let keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    let ret = ((keyCode >= 48 && keyCode <= 57) || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode));
    return ret;
  }
  ValidationMessage() {

    if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value !== null) {
      if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== null && this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== '') {
        if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value == 0) {
          if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value >= this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value) {
            this.WaiveOffCreationForm.controls.WaiveOffAmount.reset();
            //this.WaiveOffCreationForm.controls['WaiveOffAmount'].enable();
            this.IsWaiveAmountEnable = false;
            this.WaiveOffCreationForm.controls.NetRecoveryAmount.setValue(0);
            this.alertService.notify('warn', 'warn!', ' In case of partial wave off type , waive off amount must be greater than 0 and less than original penalty amount.');
            return;
          }
        }
        if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value == 1) {
          if (Math.ceil(this.WaiveOffCreationForm.controls.WaiveOffAmount.value) !== Math.ceil(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value)) {
            this.WaiveOffCreationForm.controls.WaiveOffAmount.setValue(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value);
            // this.WaiveOffCreationForm.controls.WaiveOffAmount.setValue(Math.ceil(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value));
            this.WaiveOffCreationForm.controls.NetRecoveryAmount.setValue(0);
            this.IsWaiveAmountEnable = true;

          }
        }
      }
    }

    if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== '' && this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== null) {
      if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value <= 0) {
        this.IsWaiveAmountEnable = false;
        //this.WaiveOffCreationForm.controls['WaiveOffAmount'].enable();
        this.WaiveOffCreationForm.controls.WaiveOffAmount.reset();
        this.WaiveOffCreationForm.controls.NetRecoveryAmount.reset();
        this.alertService.notify('warn', 'warn!', 'waive off amount can not be zero.');
        return;
      }
    }
    if (this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value !== '' && this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value !== null) {
      if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== '' && this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== null) {
        if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value > this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value) {
          this.IsWaiveAmountEnable = false;
          //this.WaiveOffCreationForm.controls['WaiveOffAmount'].enable();
          this.WaiveOffCreationForm.controls.WaiveOffAmount.reset();
          this.WaiveOffCreationForm.controls.NetRecoveryAmount.reset();
          this.alertService.notify('warn', 'warn!', 'waive off amount cannot be greater than original penalty amount.');
          return;
        }
      }
    }
    if (this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value !== '' && this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value !== null) {
      let calculatedvalue = 0;
      if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== '' && this.WaiveOffCreationForm.controls.WaiveOffAmount.value !== null) {
        calculatedvalue = this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value - this.WaiveOffCreationForm.controls.WaiveOffAmount.value;
        if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value !== null) {
          if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value == 0) {
            if (this.WaiveOffCreationForm.controls.WaiveOffAmount.value >= this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value) {
              this.IsWaiveAmountEnable = false;
              //this.WaiveOffCreationForm.controls['WaiveOffAmount'].enable();
              this.WaiveOffCreationForm.controls.NetRecoveryAmount.setValue(0);
              this.alertService.notify('warn', 'warn!', ' In case of partial wave off type , waive off amount must be greater than 0 and less than original penalty amount.');
              return;
            }
          }
        }
      }
      if (this.WaiveOffCreationForm.controls.IsFullWaiveOff.value == 1) {
        if (Math.ceil(this.WaiveOffCreationForm.controls.WaiveOffAmount.value) !== Math.ceil(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value)) {
          this.IsWaiveAmountEnable = true;

          // this.WaiveOffCreationForm.controls.WaiveOffAmount.setValue(Math.ceil(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value));
          this.WaiveOffCreationForm.controls.WaiveOffAmount.setValue(this.WaiveOffCreationForm.controls.OriginalPenaltyAmount.value);
          this.WaiveOffCreationForm.controls.NetRecoveryAmount.setValue(0);


        }
      }
      this.WaiveOffCreationForm.controls.NetRecoveryAmount.setValue(calculatedvalue);

    }
  }
  /**********************************Error Section End***************************************/
}

